module.exports = __webpack_public_path__ + "img/50.4b02dc0f.jpg";